import kebabCase from 'lodash/kebabCase'

import { GatheringFields } from 'main/gql/gathering'

export function gatheringPath(gathering: GatheringFields) {
  const { address, slug } = gathering
  const statePart = address && address.state ? kebabCase(address.state) : '_'
  const cityPart = address && address.city ? kebabCase(address.city) : '_'

  return `/${statePart}/${cityPart}/events/${slug}`
}
